// extracted by mini-css-extract-plugin
export var center = "newsletter-rich-text-module--center--5e2d5";
export var container = "newsletter-rich-text-module--container--9c059";
export var content = "newsletter-rich-text-module--content--f63cb";
export var icon = "newsletter-rich-text-module--icon--f3855";
export var spin = "newsletter-rich-text-module--spin--fa531";
export var titleInner = "newsletter-rich-text-module--titleInner--7488a";
export var titleText = "newsletter-rich-text-module--titleText--c1f3d";
export var title__lifestyle = "newsletter-rich-text-module--title__lifestyle--a8f02";
export var wrapper = "newsletter-rich-text-module--wrapper--c2fd1";
export var wrapper__black = "newsletter-rich-text-module--wrapper__black--2c0ce";
export var wrapper__bloodorange = "newsletter-rich-text-module--wrapper__bloodorange--e844d";
export var wrapper__chartruse = "newsletter-rich-text-module--wrapper__chartruse--e5d6d";
export var wrapper__cobalt = "newsletter-rich-text-module--wrapper__cobalt--09ee4";
export var wrapper__contain = "newsletter-rich-text-module--wrapper__contain--a50d4";
export var wrapper__emerald = "newsletter-rich-text-module--wrapper__emerald--6bdb8";
export var wrapper__paper = "newsletter-rich-text-module--wrapper__paper--0c69f";
export var wrapper__pink = "newsletter-rich-text-module--wrapper__pink--3c492";
export var wrapper__sky = "newsletter-rich-text-module--wrapper__sky--a6a67";
export var wrapper__white = "newsletter-rich-text-module--wrapper__white--a8f22";